import { JapaneseSymbol } from '../common/interfaces/japaneseSymbol'

export const KatakanaDictionary: JapaneseSymbol[] = [
  { symbol: 'ア', romaji: 'a' },
  { symbol: 'イ', romaji: 'i' },
  { symbol: 'ウ', romaji: 'u' },
  { symbol: 'エ', romaji: 'e' },
  { symbol: 'オ', romaji: 'o' },
  { symbol: 'カ', romaji: 'ka' },
  { symbol: 'キ', romaji: 'ki' },
  { symbol: 'ク', romaji: 'ku' },
  { symbol: 'ケ', romaji: 'ke' },
  { symbol: 'コ', romaji: 'ko' },
  { symbol: 'ガ', romaji: 'ga' },
  { symbol: 'ギ', romaji: 'gi' },
  { symbol: 'グ', romaji: 'gu' },
  { symbol: 'ゲ', romaji: 'ge' },
  { symbol: 'ゴ', romaji: 'go' },
  { symbol: 'サ', romaji: 'sa' },
  { symbol: 'シ', romaji: 'shi' },
  { symbol: 'ス', romaji: 'su' },
  { symbol: 'セ', romaji: 'se' },
  { symbol: 'ソ', romaji: 'so' },
  { symbol: 'ザ', romaji: 'za' },
  { symbol: 'ジ', romaji: 'ji' },
  { symbol: 'ズ', romaji: 'zu' },
  { symbol: 'ゼ', romaji: 'ze' },
  { symbol: 'ゾ', romaji: 'zo' },
  { symbol: 'タ', romaji: 'ta' },
  { symbol: 'チ', romaji: 'chi' },
  { symbol: 'ツ', romaji: 'tsu' },
  { symbol: 'テ', romaji: 'te' },
  { symbol: 'ト', romaji: 'to' },
  { symbol: 'ダ', romaji: 'da' },
  { symbol: 'ヂ', romaji: 'dji' },
  { symbol: 'ヅ', romaji: 'dzu' },
  { symbol: 'デ', romaji: 'de' },
  { symbol: 'ド', romaji: 'do' },
  { symbol: 'ナ', romaji: 'na' },
  { symbol: 'ニ', romaji: 'ni' },
  { symbol: 'ヌ', romaji: 'nu' },
  { symbol: 'ネ', romaji: 'ne' },
  { symbol: 'ノ', romaji: 'no' },
  { symbol: 'ハ', romaji: 'ha' },
  { symbol: 'ヒ', romaji: 'hi' },
  { symbol: 'フ', romaji: 'fu' },
  { symbol: 'ヘ', romaji: 'he' },
  { symbol: 'ホ', romaji: 'ho' },
  { symbol: 'バ', romaji: 'ba' },
  { symbol: 'ビ', romaji: 'bi' },
  { symbol: 'ブ', romaji: 'bu' },
  { symbol: 'ベ', romaji: 'be' },
  { symbol: 'ボ', romaji: 'bo' },
  { symbol: 'パ', romaji: 'pa' },
  { symbol: 'ピ', romaji: 'pi' },
  { symbol: 'プ', romaji: 'pu' },
  { symbol: 'ペ', romaji: 'pe' },
  { symbol: 'ポ', romaji: 'po' },
  { symbol: 'マ', romaji: 'ma' },
  { symbol: 'ミ', romaji: 'mi' },
  { symbol: 'ム', romaji: 'mu' },
  { symbol: 'メ', romaji: 'me' },
  { symbol: 'モ', romaji: 'mo' },
  { symbol: 'ヤ', romaji: 'ya' },
  { symbol: 'ユ', romaji: 'yu' },
  { symbol: 'ヨ', romaji: 'yo' },
  { symbol: 'ラ', romaji: 'ra' },
  { symbol: 'リ', romaji: 'ri' },
  { symbol: 'ル', romaji: 'ru' },
  { symbol: 'レ', romaji: 're' },
  { symbol: 'ロ', romaji: 'ro' },
  { symbol: 'ワ', romaji: 'wa' },
  { symbol: 'ヲ', romaji: 'wo' },
  { symbol: 'ン', romaji: 'n' },
]

export const KSmallKanaDictionary: JapaneseSymbol[] = [
  { symbol: 'ァ', romaji: '=a' },
  { symbol: 'ィ', romaji: '=i' },
  { symbol: 'ゥ', romaji: '=u' },
  { symbol: 'ェ', romaji: '=e' },
  { symbol: 'ォ', romaji: '=o' },
  { symbol: 'ッ', romaji: '=tsu' },
  { symbol: 'ャ', romaji: '=ya' },
  { symbol: 'ュ', romaji: '=yu' },
  { symbol: 'ョ', romaji: '=yo' },
]

export const KNVariantsDictionary: JapaneseSymbol[] = [
  { symbol: 'ナ', romaji: 'ンa' },
  { symbol: 'ニ', romaji: 'ンi' },
  { symbol: 'ヌ', romaji: 'ンu' },
  { symbol: 'ネ', romaji: 'ンe' },
  { symbol: 'ノ', romaji: 'ンo' },
]

export const KPunctuationDictionary: JapaneseSymbol[] = [
  { symbol: 'ー', romaji: '-' },
  { symbol: '。', romaji: '.' },
  { symbol: '、', romaji: ',' },
  { symbol: '「', romaji: '" ' },
  { symbol: '」', romaji: ' "' },
]
